export const categories = [
  { id: 'hot-blood', name: '热血', slug: 'hot-blood', icon: 'ri-fire-line' },
  { id: 'love', name: '恋爱', slug: 'love', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'horror', name: '悬疑', slug: 'horror', icon: 'ri-ghost-line' },
  { id: 'sci-fi', name: '科幻', slug: 'sci-fi', icon: 'ri-rocket-line' },
  { id: 'martial', name: '武侠', slug: 'martial', icon: 'ri-sword-line' },
  { id: 'slice-of-life', name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line' },
];

export const comics = [
  {
    id: '1',
    title: '斗破苍穹',
    category: 'hot-blood',
    categoryName: '热血',
    status: '连载中',
    author: '天蚕土豆',
    description: '天才少年萧炎在创造了家族空前的修炼纪录后，突然成为了废人。整整三年时间，受尽冷眼与嘲讽。在他即将绝望之时，一缕幽魂从他手上的戒指里浮现，一扇全新的大门向他开启。',
    chapters: 582,
    views: 12860000,
    rating: 9.2,
    updateTime: '2026-07-06',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20manga%20style%20young%20warrior%20with%20flame%20powers%20epic%20pose%20on%20simple%20warm%20gradient%20background%2C%20clean%20illustration%2C%20professional%20manga%20art%2C%20vibrant%20warm%20colors%20orange%20and%20red%20accents%2C%20high%20quality%20digital%20art&width=600&height=800&seq=comic-cover-01&orientation=portrait',
  },
  {
    id: '2',
    title: '完美世界',
    category: 'fantasy',
    categoryName: '奇幻',
    status: '连载中',
    author: '辰东',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。一个少年从大荒中走出，一切从这里开始。',
    chapters: 426,
    views: 9520000,
    rating: 9.5,
    updateTime: '2026-07-05',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20ancient%20fantasy%20young%20man%20with%20long%20hair%20standing%20on%20mountain%20peak%20holding%20ancient%20weapon%2C%20mystical%20atmosphere%2C%20warm%20golden%20light%2C%20simple%20gradient%20background%2C%20clean%20manga%20illustration%2C%20professional%20art&width=600&height=800&seq=comic-cover-02&orientation=portrait',
  },
  {
    id: '3',
    title: '星辰变',
    category: 'fantasy',
    categoryName: '奇幻',
    status: '已完结',
    author: '我吃西红柿',
    description: '一名孩童，天生无法修炼内功。为了得到父亲的重视，他毅然选择修炼痛苦艰难的外功。春去秋来，时光如梭，这个孩童长大了……变成了一名青年，真正改变他命运的时刻到来了。',
    chapters: 360,
    views: 7820000,
    rating: 9.0,
    updateTime: '2026-06-28',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20celestial%20warrior%20with%20starry%20cosmic%20energy%20surrounding%20him%2C%20epic%20fantasy%20pose%2C%20deep%20space%20gradient%20background%20with%20stars%2C%20professional%20manga%20illustration%2C%20clean%20vibrant%20colors%2C%20warm%20tone%20accents&width=600&height=800&seq=comic-cover-03&orientation=portrait',
  },
  {
    id: '4',
    title: '全职高手',
    category: 'hot-blood',
    categoryName: '热血',
    status: '已完结',
    author: '蝴蝶蓝',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他寄身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏。',
    chapters: 178,
    views: 15600000,
    rating: 9.7,
    updateTime: '2026-07-01',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20esports%20gamer%20young%20man%20with%20headset%20holding%20mouse%20intense%20gaming%20expression%2C%20cyberpunk%20warm%20lighting%2C%20simple%20dark%20gradient%20background%2C%20professional%20illustration%2C%20clean%20art%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
  },
  {
    id: '5',
    title: '魔道祖师',
    category: 'fantasy',
    categoryName: '奇幻',
    status: '已完结',
    author: '墨香铜臭',
    description: '前世的魏无羡万人唾骂，声名狼藉。被情同手足的师弟带人端了老巢，纵横一世，死无全尸。曾掀起腥风血雨的一代魔道祖师，重生成了一个……脑残。',
    chapters: 256,
    views: 20100000,
    rating: 9.8,
    updateTime: '2026-06-30',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20elegant%20ancient%20man%20in%20white%20robes%20holding%20flute%2C%20cherry%20blossom%20petals%20floating%2C%20romantic%20mystical%20atmosphere%2C%20warm%20pink%20and%20cream%20gradient%20background%2C%20beautiful%20digital%20art%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-05&orientation=portrait',
  },
  {
    id: '6',
    title: '一人之下',
    category: 'martial',
    categoryName: '武侠',
    status: '连载中',
    author: '米二',
    description: '普通大学生张楚岚，某天突然遭遇了僵尸的袭击。一个神秘少女的出现解救了张楚岚，而她的身份竟然是……',
    chapters: 512,
    views: 11500000,
    rating: 9.3,
    updateTime: '2026-07-06',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20modern%20martial%20arts%20young%20man%20in%20casual%20clothes%20using%20supernatural%20energy%2C%20urban%20fantasy%2C%20warm%20sepia%20gradient%20background%2C%20clean%20professional%20manga%20illustration&width=600&height=800&seq=comic-cover-06&orientation=portrait',
  },
  {
    id: '7',
    title: '狐妖小红娘',
    category: 'love',
    categoryName: '恋爱',
    status: '连载中',
    author: '小新',
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限。人死妖活，于是产生了人妖续缘之法。涂山狐妖一族以红线仙为职业，帮助前世恋人再续前缘。',
    chapters: 398,
    views: 8920000,
    rating: 9.4,
    updateTime: '2026-07-04',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20beautiful%20fox%20spirit%20girl%20with%20red%20hair%20and%20fox%20ears%2C%20romantic%20cherry%20blossom%20scene%2C%20soft%20warm%20pink%20gradient%20background%2C%20elegant%20digital%20illustration%2C%20professional%20manga%20art&width=600&height=800&seq=comic-cover-07&orientation=portrait',
  },
  {
    id: '8',
    title: '镇魂街',
    category: 'horror',
    categoryName: '悬疑',
    status: '连载中',
    author: '许辰',
    description: '镇魂街，乃吸纳亡灵镇压恶灵之地。一个人灵共存的世界，只有拥有守护灵的寄灵人才可进入。普通的应届大学毕业生夏铃，在求职之际误入罗刹街，从此踏上了一条不归路。',
    chapters: 345,
    views: 7230000,
    rating: 9.1,
    updateTime: '2026-07-03',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20dark%20urban%20fantasy%20young%20man%20with%20guardian%20spirit%20warrior%20behind%20him%2C%20mysterious%20atmosphere%2C%20warm%20dark%20crimson%20gradient%20background%2C%20professional%20illustration%2C%20clean%20art&width=600&height=800&seq=comic-cover-08&orientation=portrait',
  },
  {
    id: '9',
    title: '武动乾坤',
    category: 'martial',
    categoryName: '武侠',
    status: '已完结',
    author: '天蚕土豆',
    description: '修炼一途，乃窃阴阳，夺造化，转涅盘，握生死，掌轮回。大炎王朝青阳镇，一个落魄的林氏子弟——林动，在山洞间偶然捡到一块神秘的石符，从此他的命运开始改变！',
    chapters: 480,
    views: 10500000,
    rating: 9.0,
    updateTime: '2026-06-25',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20ancient%20martial%20arts%20young%20man%20in%20training%20robes%20performing%20powerful%20palm%20strike%2C%20dramatic%20wind%20effects%2C%20warm%20golden%20brown%20gradient%20background%2C%20professional%20digital%20art&width=600&height=800&seq=comic-cover-09&orientation=portrait',
  },
  {
    id: '10',
    title: '大理寺日志',
    category: 'comedy',
    categoryName: '搞笑',
    status: '连载中',
    author: 'RC',
    description: '以唐朝武则天上位初期为背景，讲述了大理寺众人在白猫少卿李饼的带领下，处理各种离奇案件的故事。',
    chapters: 210,
    views: 5680000,
    rating: 9.5,
    updateTime: '2026-07-02',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20ancient%20Chinese%20official%20in%20Tang%20dynasty%20robes%20with%20cat%20features%2C%20humorous%20expression%2C%20warm%20cream%20and%20sepia%20gradient%20background%2C%20clean%20professional%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
  },
  {
    id: '11',
    title: '天官赐福',
    category: 'fantasy',
    categoryName: '奇幻',
    status: '已完结',
    author: '墨香铜臭',
    description: '八百年前，谢怜是金枝玉叶的太子殿下。风光无限的天之骄子，一朝得道飞升成为万人供奉的武神。如今，他又飞升了，依旧是万众瞩目的武神，只不过……降级了。',
    chapters: 220,
    views: 18900000,
    rating: 9.6,
    updateTime: '2026-06-20',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20beautiful%20ancient%20deity%20in%20flowing%20white%20and%20red%20robes%20descending%20from%20heavens%2C%20golden%20divine%20light%2C%20ethereal%20warm%20gradient%20background%2C%20professional%20digital%20illustration%2C%20clean%20manga%20art&width=600&height=800&seq=comic-cover-11&orientation=portrait',
  },
  {
    id: '12',
    title: '非人哉',
    category: 'comedy',
    categoryName: '搞笑',
    status: '连载中',
    author: '一汪空气',
    description: '脑洞大开的四格漫画，讲述神话传说中的神仙妖怪在现代社会的搞笑日常。九尾狐九月、龙王三太子敖烈、小玉兔等角色，在现代都市中的趣味生活。',
    chapters: 625,
    views: 13500000,
    rating: 9.4,
    updateTime: '2026-07-06',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20cute%20mythical%20creatures%20in%20modern%20office%20setting%2C%20humorous%20slice%20of%20life%2C%20warm%20pastel%20cream%20gradient%20background%2C%20clean%20professional%20illustration%2C%20light%20comedy%20tone&width=600&height=800&seq=comic-cover-12&orientation=portrait',
  },
];